'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uniqid = _interopRequireDefault(require("uniqid"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _getAcceptedMIMES = _interopRequireDefault(require("Components/Forms/Functions/getAcceptedMIMES"));
var _getFormData = _interopRequireDefault(require("Components/Forms/Functions/getFormData"));
var _ajaxRequest = _interopRequireDefault(require("Functions/ajax/ajaxRequest"));
var _ImageProcessing = _interopRequireDefault(require("Icons/ImageProcessing"));
var _TextFile = _interopRequireDefault(require("Icons/TextFile"));
var _Picture = _interopRequireDefault(require("Icons/Picture"));
var _Success = _interopRequireDefault(require("Icons/Success"));
var _Reload = _interopRequireDefault(require("Icons/Reload"));
var _Upload = _interopRequireDefault(require("Icons/Upload"));
var _Error = _interopRequireDefault(require("Icons/Error"));
var _PDFFile = _interopRequireDefault(require("Icons/PDFFile"));
var _S3Image = _interopRequireDefault(require("Pure/S3Image"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
var _Routing = require("Functions/Routing");
var _utilities = require("Shared/utilities");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const {
  app,
  axios,
  numeral,
  moment
} = window;
const status_icon_labels = {
  uploaded: 'Prêt',
  uploading: 'Envoi en cours...',
  upload_failed: 'Échec de l\'envoi',
  optimizing: 'Optimisation de l\'image...'
};
const status_icon_Components = {
  uploaded: _Success.default,
  uploading: _Upload.default,
  upload_failed: _Error.default,
  optimizing: _ImageProcessing.default
};
class FileInput extends _react.Component {
  constructor() {
    var _this;
    super(...arguments);
    _this = this;
    (0, _defineProperty2.default)(this, "state", _objectSpread(_objectSpread({
      id: (0, _uniqid.default)(),
      files_to_upload: []
    }, (0, _getAcceptedMIMES.default)(this.props)), {}, {
      loading: false
    }));
    (0, _defineProperty2.default)(this, "queue", {});
    (0, _defineProperty2.default)(this, "removeFile", (e, preview_to_remove) => {
      const component = this,
        props = this.props,
        state = this.state;
      e.preventDefault();
      app.emit({
        event: 'documentClick'
      });
      const previews = (props.value || []).filter(preview => preview.id !== preview_to_remove.id);

      // Prevent current file to stay in browser input
      // It's a common bug when you try to select twice a file with the same filename
      // And nothing happen the second time
      component.clearHTMLValue();
      component.cancelUpload(preview_to_remove.id);
      props.onChange({
        e: undefined,
        previews: previews,
        name: props.name,
        source: 'native-remove'
      });
      state['progress_' + preview_to_remove.id] = undefined;
      state['uploading_' + preview_to_remove.id] = undefined;
      delete state['progress_' + preview_to_remove.id];
      delete state['uploading_' + preview_to_remove.id];
      component.setState({
        files_to_upload: state.files_to_upload.filter(data => data.preview_id !== preview_to_remove.id)
      });
    });
    (0, _defineProperty2.default)(this, "handleFieldChange", _ref => {
      let {
        e,
        value,
        name,
        index
      } = _ref;
      const component = this,
        props = this.props,
        state = this.state;

      // Prevent update on field DidMount
      if (!e) return;
      const preview = props.value[index];
      if (!preview) return;
      preview[name] = value;
      if (props.value[0].title.length > 40) return;
      props.onChange({
        e: undefined,
        previews: props.value,
        name: props.name,
        source: 'native-remove'
      });
    });
    (0, _defineProperty2.default)(this, "clearHTMLValue", () => {
      const component = this,
        props = this.props,
        state = this.state;
      (document.getElementById(state.id) || {}).value = '';
    });
    (0, _defineProperty2.default)(this, "reorder", (list, source_i, destination_i) => {
      const result = Array.from(list);
      const [removed] = result.splice(source_i, 1);
      result.splice(destination_i, 0, removed);
      return result;
    });
    (0, _defineProperty2.default)(this, "handleDragEnd", function () {
      let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      let component = _this,
        props = _this.props,
        state = _this.state;
      const {
        destination,
        source
      } = data;
      if (!destination || source.index === destination.index) return;
      const previews = props.value || [];
      props.onChange({
        e: undefined,
        previews: component.reorder(previews, source.index, destination.index),
        name: props.name,
        source: 'reorder'
      });
    });
    (0, _defineProperty2.default)(this, "cancelUpload", id => {
      const component = this,
        props = this.props,
        state = this.state;

      // Nothing to cancel or already canceled
      if (!component.queue[id]) return;

      // Cancel request
      component.queue[id].token.cancel();
      component.clearQueue(id);
    });
    (0, _defineProperty2.default)(this, "clearQueue", id => {
      const component = this,
        props = this.props,
        state = this.state;
      component.queue[id] = undefined;
      delete component.queue[id];
    });
    (0, _defineProperty2.default)(this, "retry", (e, preview_id) => {
      const component = this,
        props = this.props,
        state = this.state;
      const file = state.files_to_upload.find(data => data.preview_id === preview_id);
      file.ready_to_upload = true;
      component.upload(preview_id);
    });
    (0, _defineProperty2.default)(this, "upload", async preview_id => {
      const component = this,
        props = this.props,
        state = this.state;
      const file = state.files_to_upload.find(data => data.preview_id === preview_id);
      if (!file || file.ready_to_upload !== true) return;
      const preview = props.value.find(preview => preview.id === preview_id);
      const already_launched = component.queue[preview.id] ? true : false;
      if (already_launched) return;
      file.ready_to_upload = false;
      component.setState({
        ['uploading_' + preview_id]: true
      });
      delete file.upload_failed;
      component.setState({
        files_to_upload: state.files_to_upload
      });
      let form_data = (0, _getFormData.default)({
        state: _objectSpread(_objectSpread({}, preview), {}, {
          public: props.public === true
        }),
        pattern: ''
      });
      form_data.append('__files', file.binary);
      let response,
        req_token = axios.CancelToken.source();
      component.queue[preview.id] = {
        token: req_token
      };
      let ticking = true;
      try {
        response = await (0, _ajaxRequest.default)((0, _Routing.action)('UploadToObjectStorage'), {
          redirect: false,
          files: true,
          axios_token: req_token,
          data: form_data,
          min_duration: 1200,
          axios_params: {
            onUploadProgress: onUpload
          }
        });
      } catch (e) {
        component.setState({
          ['uploading_' + preview_id]: false,
          ['progress_' + preview.id]: 0
        });
        component.clearQueue(preview.id);
        file.upload_failed = true;
        return component.setState({
          files_to_upload: state.files_to_upload
        });
      }
      ticking = false;
      component.clearQueue(preview.id);
      component.setState({
        ['uploading_' + preview_id]: false,
        ['progress_' + preview.id]: 100,
        files_to_upload: state.files_to_upload.filter(file => file.preview_id !== preview.id)
      });
      preview.status = 'uploaded';

      // Update preview with upload info (access url, variants, etc.)
      Object.assign(preview, response.file_infos || {});
      props.onChange({
        e: undefined,
        previews: props.value,
        name: props.name,
        source: 'upload'
      });
      function onUpload(event) {
        const progress = numeral(event.loaded).divide(event.total).multiply(100).format('0.00');
        if (ticking === false && progress < 99) return;
        ticking = false;
        window.setTimeout(function () {
          if (preview.status === 'uploaded') return;
          ticking = true;
          const update = {
            ['progress_' + preview.id]: Number(progress)
          };
          if (progress >= 99 && preview.MIME.startsWith('image/')) {
            file.optimizing = true;
            update.files_to_upload = state.files_to_upload;
          }
          component.setState(update);
        }, 220);
      }
    });
  }
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (Array.isArray(props.value)) return;
    props.onChange({
      e: null,
      previews: [],
      name: props.name,
      source: 'DidMount'
    });
    component.setState({
      loading: false
    });
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    Object.keys(component.queue).forEach(function (id) {
      component.cancelUpload(id);
    });
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.accept !== prev_props.accept) {
      component.setState(component.getAcceptedMIMES());
    }

    // Start ready uploads
    state.files_to_upload.filter(data => data.ready_to_upload === true).forEach(data => component.upload(data.preview_id));
  }
  // async function hasAlpha = (file) =>
  // {
  // 	return new Promise((resolve, reject) => {
  // 	let hasAlpha = false;
  // 	const canvas = document.querySelector('canvas');
  // 	const ctx = canvas.getContext('2d');

  // 	const img = new Image();
  // 	img.crossOrigin = 'Anonymous';
  // 	img.onerror = reject;
  // 	img.onload = function() {
  // 	canvas.width = img.width;
  // 	canvas.height = img.height;

  // 	ctx.drawImage(img, 0, 0);
  // 	const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;

  // 	for (let j = 0; j < imgData.length; j += 4) {
  // 		if (imgData[j + 3] < 255) {
  // 		hasAlpha = true;
  // 		break;
  // 		}
  // 	}
  // 		resolve(hasAlpha);
  // 	};
  // 		img.src = URL.createObjectURL(file);
  // 	});
  // }

  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const warn_size = Number((0, _utilities.formatNum)(props['warn-size'], '0.00'));
    const max_size = Number((0, _utilities.formatNum)(props['max-size'], '0.00'));
    const input_element = /*#__PURE__*/_react.default.createElement("input", {
      type: "file",
      className: "c-form-element__file",
      name: props.name,
      id: state.id,
      onChange: handleChange,
      multiple: props.multiple,
      accept: state.accepted_extensions
    });
    if (props.hidden === true) return input_element;
    let class_name = props.className || 'c-form-element c-form-element--file';
    let status = props.status[props.name] || {};
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement("div", {
      className: "c-form-element__file-loader"
    }, /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['small', 'primary', 'bg-white']
    })) : undefined;
    const label = props.label ? /*#__PURE__*/_react.default.createElement("label", {
      className: "c-form-label c-form-label--file",
      htmlFor: state.id
    }, props.label) : undefined;
    let info, warning, error;
    if (status.info) {
      info = /*#__PURE__*/_react.default.createElement("div", {
        className: "c-form-label c-form-label--info"
      }, status.info);
      class_name += ' c-form-element--info';
    }
    if (status.warning) {
      warning = /*#__PURE__*/_react.default.createElement("div", {
        className: "c-form-label c-form-label--file c-form-label--warning"
      }, status.warning);
      class_name += ' c-form-element--warning';
    }
    if (status.error) {
      error = /*#__PURE__*/_react.default.createElement("div", {
        className: "c-form-label c-form-label--file c-form-label--error"
      }, status.error);
      class_name += ' c-form-element--error';
    }
    const previews = (props.value || []).map(function (preview, index) {
      let is__editable = true,
        is__removable = props['read-only'] !== true;
      const file_to_upload = state.files_to_upload.find(data => data.preview_id === preview.id);
      let filename = preview.filename || '';
      let extension = filename.slice(filename.lastIndexOf('.'), filename.length);
      filename = filename.slice(0, filename.indexOf(extension));

      // shorten filename if too long and add '...'
      if (filename.length > 20) {
        filename = filename.slice(0, 17) + '...';
      }
      filename += extension;
      const Icon = preview.MIME === 'application/pdf' ? _PDFFile.default : preview.MIME.startsWith('image/') ? _Picture.default : _TextFile.default;
      const thumbnail = (preview.variants || []).find(variant => variant.width < 600);
      let url = preview.url;
      if (url && (0, _utilities.isTrue)(preview.renamed) === false) {
        url = (0, _Routing.action)('GetTmpImage').replace(':filename', preview.filename).replace(':inline', ['image', 'pdf'].includes(preview.type));
      }
      const image = preview.url ? /*#__PURE__*/_react.default.createElement("a", {
        href: url,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "c-file-thumbnail__link",
        type: "application/pdf"
      }, Icon === _Picture.default ? /*#__PURE__*/_react.default.createElement(_S3Image.default, {
        data: preview,
        variant: thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.width,
        className: "c-file-thumbnail__img"
      }) : /*#__PURE__*/_react.default.createElement(Icon, {
        className: "c-file-thumbnail__icon",
        "data-mime": preview.MIME
      })) : /*#__PURE__*/_react.default.createElement(Icon, {
        className: "c-file-thumbnail__icon",
        "data-mime": preview.MIME
      });
      const progress = state['progress_' + preview.id] || 0;
      const title_name = props.multiple === false ? props.name + '[title]' : props.name + '[' + index + '][title]';
      const preview_loader = state['uploading_' + preview.id] === true ? /*#__PURE__*/_react.default.createElement("div", {
        className: "c-file-thumbnail__progress"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _bemit.default)('c-fillable-indicator', ['upload'])
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "c-fillable-indicator__bar",
        style: {
          width: progress + '%'
        }
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "c-file-thumbnail__progress-label"
      }, numeral(progress).format('0[.]00').replace(',', '.'), '%')) : undefined;
      const is__type_invalid = state.accepted_MIMES.includes(preview.MIME) === false;
      if (is__type_invalid) is__editable = false;
      const warning_message = preview.status === 'uploaded' ? undefined : is__type_invalid ? /*#__PURE__*/_react.default.createElement("div", {
        className: "c-file-thumbnail__error"
      }, /*#__PURE__*/_react.default.createElement(_Error.default, {
        className: "c-file-thumbnail__error-icon"
      }), /*#__PURE__*/_react.default.createElement("span", null, "Ce type de fichier n'est pas autoris\xE9.")) : preview.size_MB > max_size ? /*#__PURE__*/_react.default.createElement("div", {
        className: "c-file-thumbnail__error"
      }, /*#__PURE__*/_react.default.createElement(_Error.default, {
        className: "c-file-thumbnail__error-icon"
      }), /*#__PURE__*/_react.default.createElement("span", null, "La taille du fichier d\xE9passe le maximum autoris\xE9", ' (', numeral(max_size).format('0[.]00'), ' Mo).')) : preview.size_MB > warn_size && progress < 100 ? /*#__PURE__*/_react.default.createElement("div", {
        className: "c-file-thumbnail__warning"
      }, /*#__PURE__*/_react.default.createElement(_Error.default, {
        className: "c-file-thumbnail__warning-icon"
      }), /*#__PURE__*/_react.default.createElement("span", null, "Attention, ce fichier a un poids important, assurez-vous d'avoir une connection internet rapide, dans le cas contraire son envoi pourra\xEEt \xEAtre long ou \xE9chouer.")) : undefined;
      let info_status = preview.status;
      if (state['uploading_' + preview.id] === true) {
        if ((file_to_upload === null || file_to_upload === void 0 ? void 0 : file_to_upload.optimizing) === true) {
          info_status = 'optimizing';
        } else {
          info_status = 'uploading';
        }
      } else if ((file_to_upload === null || file_to_upload === void 0 ? void 0 : file_to_upload.upload_failed) === true) {
        info_status = 'upload_failed';
      }
      if (info_status === 'uploaded' && (0, _utilities.isTrue)(preview.renamed)) {
        info_status = 'stored';
      }
      const IconComponent = status_icon_Components[info_status];
      const status_icon = IconComponent ? /*#__PURE__*/_react.default.createElement(IconComponent, {
        className: "c-file-thumbnail__status-icon",
        "data-status": info_status
      }) : undefined;
      const displayed_content = preview_loader ? preview_loader : /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        onChange: _ref2 => {
          let {
            e,
            value
          } = _ref2;
          return component.handleFieldChange({
            e,
            value,
            name: 'title',
            index
          });
        },
        value: preview.title,
        name: title_name,
        status: props.status,
        placeholder: " Titre",
        "read-only": is__editable === false
      });
      let status_label = status_icon_labels[info_status];
      if (info_status === 'uploading' && progress > 99) {
        status_label = 'Traitement...';
      }
      const content = /*#__PURE__*/_react.default.createElement("div", {
        className: "c-file-thumbnail__content"
      }, image, /*#__PURE__*/_react.default.createElement("div", {
        className: "c-file-thumbnail__title",
        htmlFor: state.id
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "c-file-thumbnail__file-size"
      }, preview.size_MB > 1 ? numeral(preview.size_MB).format('0,0[.]00').split(',').join(' ') : numeral(preview.size_KB).format('0,0[.]00').split(',').join(' '), ' ', preview.size_MB > 1 ? 'Mo' : 'Ko'), /*#__PURE__*/_react.default.createElement("div", {
        className: "c-file-thumbnail__file-name"
      }, filename), status_icon, status_icon ? /*#__PURE__*/_react.default.createElement("span", {
        className: "c-file-thumbnail__status-label"
      }, status_label) : undefined, (file_to_upload === null || file_to_upload === void 0 ? void 0 : file_to_upload.upload_failed) === true ? /*#__PURE__*/_react.default.createElement(_Button.default, {
        type: "button",
        title: "R\xE9essayer",
        className: "c-file-thumbnail__retry",
        onClick: e => component.retry(e, preview.id)
      }, /*#__PURE__*/_react.default.createElement(_Reload.default, {
        className: "c-file-thumbnail__retry-icon"
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "c-file-thumbnail__retry-label"
      }, "R\xE9essayer")) : undefined, displayed_content), is__removable ? /*#__PURE__*/_react.default.createElement(_Button.default, {
        type: "button",
        title: "Enlever",
        className: "c-file-thumbnail__delete",
        onClick: e => component.removeFile(e, preview)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "c-file-thumbnail__delete-icon"
      })) : undefined, warning_message);
      let output = /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Draggable, {
        key: preview.id,
        draggableId: preview.id,
        index: index
      }, (provided, snapshot) => /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
        ref: provided.innerRef
      }, provided.draggableProps, provided.dragHandleProps, {
        className: "c-file-thumbnail"
      }), content));
      return output;
    });
    let toggle = props['read-only'] !== true ? /*#__PURE__*/_react.default.createElement(_Button.default, {
      htmlFor: state.id,
      component: "label",
      className: props['button-class'] || (0, _bemit.default)('c-flat-btn')
    }, props.multiple === true ? props['add-label'] || 'Ajouter' : previews.length === 0 ? props['add-label'] || 'Ajouter' : props['edit-label'] || 'Modifier') : undefined;
    if (props['removable-only'] === true) {
      toggle = undefined;
    }
    let output = /*#__PURE__*/_react.default.createElement("div", {
      className: class_name
    }, label, info, warning, error, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-form-element__file-content"
    }, input_element, props.children, /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.DragDropContext, {
      onDragEnd: component.handleDragEnd
    }, /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Droppable, {
      droppableId: 'droppable-file-' + state.id
    }, (provided, snapshot) => /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, provided.droppableProps, {
      ref: provided.innerRef
    }), previews, provided.placeholder))), toggle, loader));
    return output;
    async function handleChange(e) {
      let picked_files = e.target.files;
      e.preventDefault();
      if (props['read-only'] === true) return;
      if (picked_files.length === 0) return;
      let previews = (props.value || []).slice(0);
      component.setState({
        loading: true
      });
      let files_count = picked_files.length;
      if (props.multiple === false) {
        files_count = 1;
      }
      let promises = [],
        files_to_upload = [];
      for (let i = 0; i < files_count; i++) {
        promises.push(fileListener(picked_files[i]));
      }
      await Promise.all(promises);
      component.clearHTMLValue();
      props.onChange({
        e: e,
        previews: previews,
        name: props.name,
        source: 'native-add'
      });
      component.setState({
        loading: false,
        files_to_upload: (state.files_to_upload || []).concat(files_to_upload)
      });
      function fileListener(file) {
        let resolve, reject;
        let reader = new FileReader();
        reader.onloadend = function () {
          let preview = {
            id: (0, _uniqid.default)(),
            model: props.model,
            field: props.field,
            form_name: props.name,
            filename: file.name,
            original_filename: file.name,
            status: 'picked',
            file_size: file.size,
            // bytes (octets)

            size_MB: numeral(file.size) // BASE 10
            .divide(1000).divide(1000).format('0.00'),
            size_KB: numeral(file.size) // BASE 10
            .divide(1000).format('0.00'),
            MIME: file.type
          };
          const file_to_upload = {
            preview_id: preview.id,
            ready_to_upload: preview.MIME.startsWith('image/') ? false // set after getting image dims
            : [preview.size_MB <= max_size, state.accepted_MIMES.includes(preview.MIME)].every(condition => condition),
            binary: file
          };

          // remove previous image if only one is allowed
          if (props.multiple === false) {
            previews = [];
          }
          if (preview.MIME.startsWith('image/')) {
            const dim_image = document.createElement('img');
            dim_image.setAttribute('src', reader.result);
            dim_image.addEventListener('load', function (e) {
              preview.height = dim_image.naturalHeight;
              preview.width = dim_image.naturalWidth;
              const max_size = Number((0, _utilities.formatNum)(props['max-size'], '0.00'));
              file_to_upload.ready_to_upload = [preview.size_MB <= max_size, state.accepted_MIMES.includes(preview.MIME)].every(condition => condition);
              files_to_upload.push(file_to_upload);
              previews.push(preview);
              return resolve();
            });
          } else {
            files_to_upload.push(file_to_upload);
            previews.push(preview);
            return resolve();
          }
        };
        return new Promise(function (ok, err) {
          reader.readAsDataURL(file);
          resolve = ok;
          reject = err;
        });
      }
    }
  }
}
exports.default = FileInput;
FileInput.propTypes = {
  'read-only': _propTypes.default.bool,
  multiple: _propTypes.default.bool,
  hidden: _propTypes.default.bool,
  model: _propTypes.default.string.isRequired,
  field: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  'button-class': _propTypes.default.string,
  'edit-label': _propTypes.default.string,
  'add-label': _propTypes.default.string,
  className: _propTypes.default.string,
  accept: _propTypes.default.string,
  label: _propTypes.default.string,
  status: _propTypes.default.object.isRequired,
  onChange: _propTypes.default.func
};
FileInput.defaultProps = {
  'read-only': false,
  multiple: false,
  hidden: false,
  'warn-size': '6',
  'max-size': '5000',
  // see getAcceptedMIMES (image, pdf, text, zip, etc.)
  accept: 'image'
};
